import {defineAsyncComponent} from 'vue'

export default (app: any) => {
	app.component('profile', defineAsyncComponent(() => import(/* webpackChunkName: "ProfileSettings" */ './Profile.vue')))
}
